import { QueryClient } from 'react-query';
import { ApiError } from '../jsx/errors/ApiError';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: 30 * 60 * 1000,
      retry(failureCount, error) {
        /**
         * Never retry aborted requests. An abort means a newer request superseded
         * this one, so retrying would re-fire (and re-cancel) the request we just
         * cancelled.
         */
        if (error instanceof DOMException && error.name === 'AbortError') {
          return false;
        }

        /**
         * Retry on all errors except ApiError and after more than 2 failures.
         * ApiError is thrown when the API returns a 2xx with success=false.
         * For those errors, we don't want to retry. We want to show the error to the user.
         */
        return !(error instanceof ApiError || failureCount > 2);
      },
    },
    mutations: {
      // mutation options
    },
  },
});

export enum QueryFeature {
  AutomatedAccount = 'AutomatedAccount',
  Settings = 'Settings',
  TransferMoney = 'TransferMoney',
  AssetBucketingResults = 'AssetBucketingResults',
  AccountOpening = 'AccountOpening',
  Newsfeed = 'Newsfeed',
  Authentication = 'Authentication',
  ClientAccess = 'ClientAccess',
  Campaigns = 'Campaigns',
  RiskToleranceWorkflow = 'RiskToleranceWorkflow',
  ClientList = 'ClientList',
  ProposedPlans = 'ProposedPlans',
  MyAccount = 'MyAccount',
  RISA = 'RISA',
  WhatIfs = 'WhatIfs',
  Workflow = 'Workflow',
  Profile = 'Profile',
  TopNav = 'TopNav',
  ClientStartPage = 'ClientStartPage',
  DocumentVault = 'DocumentVault',
  AccountPerformanceReporting = 'AccountPerformanceReporting',
  ClientSettings = 'ClientSettings',
  NetWorthWidget = 'NetWorthWidget',
  AssetBucketingEdit = 'AssetBucketingEdit',
  FinancialPlan = 'FinancialPlan',
  GoalsSummary = 'GoalsSummary',
  ClientGetStarted = 'ClientGetStarted',
  BeFi20 = 'BeFi20',
  ContactAdvisor = 'ContactAdvisor',
  AddAccountsModal = 'AddAccountsModal',
  EstatePlanning = 'EstatePlanning',
  ApexStatusViews = 'ApexStatusViews',
  Admin = 'Admin',
  PulseCheck = 'PulseCheck',
  GoalTrack = 'GoalTrack',
  ActionStepsReport = 'ActionStepsReport',
  NetWorthPrint = 'NetWorthPrint',
  CharitableGivingWorkflow = 'CharitableGivingWorkflow',
  CurrentYearAssumptions = 'CurrentYearAssumptions',
  PDF = 'PDF',
  AnnuityPurchase = 'AnnuityPurchase',
  Dashboard = 'Dashboard',
  NetWorth = 'NetWorth',
  CharitableGiving = 'CharitableGiving',
  PersonalFinanceTemplate = 'PersonalFinanceTemplate',
  PdfReconciliation = 'PdfReconciliation',
}
